<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="org-finder-dialog"
  [showHeader]="false"
  (onHide)="closeDialog()"
  >
  <div class="dialog-content" [class.rtl]="isRTL" [class.ltr]="!isRTL" [attr.dir]="isRTL ? 'rtl' : 'ltr'">
    <div class="dialog-icon">
      <i class="pi pi-building"></i>
    </div>

    <h2 class="dialog-title">{{ 'AUTH.ORG_FINDER.TITLE' | translate }}</h2>
    <p class="dialog-subtitle">{{ 'AUTH.ORG_FINDER.SUBTITLE' | translate }}</p>

    <form [formGroup]="form" (ngSubmit)="continue()" [attr.dir]="isRTL ? 'rtl' : 'ltr'">
      <div class="form-field">
        <label for="orgCode">{{ 'AUTH.ORG_FINDER.LABEL' | translate }}</label>
        <div class="input-wrapper" [class.rtl]="isRTL" [class.ltr]="!isRTL">
          <i class="pi pi-search input-icon"></i>
          <input type="text" id="orgCode" pInputText formControlName="orgCode" [placeholder]="'AUTH.ORG_FINDER.PLACEHOLDER' | translate" autocomplete="off" />
        </div>
        @if (!form.get('orgCode')?.hasError('pattern') || !form.get('orgCode')?.touched) {
          <small class="help-text">
            {{ 'AUTH.ORG_FINDER.HINT' | translate }}
          </small>
        }
        @if (form.get('orgCode')?.touched && form.get('orgCode')?.hasError('pattern')) {
          <small class="error-text">
            <i class="pi pi-exclamation-circle"></i>
            {{ 'AUTH.ORG_FINDER.INVALID_FORMAT' | translate }}
          </small>
        }
      </div>

      <div class="button-group">
        <button type="button" pButton class="p-button-outlined" (click)="closeDialog()" [disabled]="loading">
          {{ 'COMMON.BUTTONS.CANCEL' | translate }}
        </button>
        <button type="submit" pButton [disabled]="loading || form.invalid" [loading]="loading">
          {{ 'COMMON.BUTTONS.CONTINUE' | translate }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>
